import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

import { AnimateFrom } from '@mlb/react-patterns/components/AnimatedModal/animatedModal.types.ts';

import { useKeyPress } from 'bdvp-common/src/hooks';
import { useDictionary } from 'bdvp-common/src/hooks/config';
import { keyConstants } from 'bdvp-common/src/utils';
import Modal from 'bdvp-common/src/containers/Modal';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';
import { Tracking } from 'bdvp-tracking';

import Content from './Content';
import Footer from './Footer';

const ANIMATION_DURATION = 0.3;
const { SEARCH_SORT_MODAL_NAME } = modalConstants;
const { TAB } = keyConstants;
const keysToTrack = [TAB];

const SortModal = ({
    options,
    selected,
    hideSortModal,
    applySearchSort,
}) => {

    const dictionary = useDictionary();
    const closeButtonRef = React.useRef(null);
    const applyButtonRef = React.useRef(null);

    const [
        selectedOption,
        setSelectedOption,
    ] = React.useState(selected);

    const keysTrackingCB = (event) => {

        if (event.target === applyButtonRef.current) {

            event.preventDefault();
            closeButtonRef.current.focus();

        }

    };

    const shiftKeyTrackingCB = (event) => {

        if (event.target === closeButtonRef.current) {

            event.preventDefault();
            applyButtonRef.current.focus();

        }

    };

    const callBackProps = {
        cb: keysTrackingCB,
        shiftCB: shiftKeyTrackingCB,
    };

    useKeyPress(keysToTrack, callBackProps);

    return (
        <Modal
            name={SEARCH_SORT_MODAL_NAME}
            width={'100%'}
            height={'99%'}
            overlay={true}
            animate={true}
            animateFrom={AnimateFrom.BOTTOM}
            animationDuration={ANIMATION_DURATION}
            position={{
                bottom: 0,
                left: 0,
            }}
            handlers={
                {
                    onClosed: () => {

                        setSelectedOption(selected);

                    },
                }
            }
            headerTitle={dictionary.sort_by ?? 'Sort By'}
            modalFooter={
                <Footer
                    onApplyButtonClick={() => {

                        Tracking.trackSortApplyButtonClick(selectedOption?.label);
                        applySearchSort(selectedOption?.value);
                        hideSortModal();

                    }}
                    applyButtonRef={applyButtonRef}
                    dictionary={dictionary}
                />
            }
            closeButtonRef={closeButtonRef}
            closeButtonRight={true}
        >
            <Content
                options={options}
                selected={selectedOption}
                dictionary={dictionary}
                onOptionClick={(option) => {

                    Tracking.trackSortSelect(option?.label);
                    setSelectedOption(option);

                }}
            />
        </Modal>
    );

};

SortModal.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
        })
    ).isRequired,
    selected: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
    }),
    hideSortModal: PropTypes.func,
    applySearchSort: PropTypes.func,
};

SortModal.defaultProps = {
    selected: null,
    hideSortModal: _noop,
    applySearchSort: _noop,
};

export default SortModal;
